import { createApi } from '@reduxjs/toolkit/query/react'
import { HYDRATE } from 'next-redux-wrapper'

import { ArticleDetail, ArticleListItem } from '~/shared/components/Articles/ArticlesList/ArticlesList.types'
import { SanityQuery } from '~/redux/utils/sanity-query'
import { getBlogPostDetailQuery, getBlogPostsListQuery } from '~/shared/queries/blog'

export const blogApi = createApi({
  reducerPath: 'blogApi',
  baseQuery: SanityQuery,
  tagTypes: [],
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath]
    }
  },
  endpoints: (builder) => ({
    getBlogPostsList: builder.query<ArticleListItem[], { language: string }>({
      query: (queryParams) => ({
        queryString: getBlogPostsListQuery,
        queryParams,
      }),
    }),

    getBlogPostDetail: builder.query<ArticleDetail, { language: string; slug: string }>({
      query: (queryParams) => ({
        queryString: getBlogPostDetailQuery,
        queryParams,
      }),
    }),
  }),
})

export const {
  useGetBlogPostsListQuery,
  useGetBlogPostDetailQuery,
  util: { getRunningQueriesThunk },
} = blogApi

export const { getBlogPostsList, getBlogPostDetail } = blogApi.endpoints
